import * as React from 'react';
import { connect } from 'react-redux';
import CoreSelectedFlight from '@websky/core/src/Checkout/components/Checkout/SelectedFlight/SelectedFlight';
import { getOrder } from '@websky/core/src/Checkout/store/order/selectors';
import css from './SelectedFlight.css';
import cn from 'classnames';
import * as utils from '../CurrencyWarning/utils';
import CurrencyWarning from '../CurrencyWarning/CurrencyWarning';
const SelectedFlight = props => {
    const showNote = utils.needShowWarning(props.order.priceToPay.total);
    return (React.createElement("div", { className: cn(css.selectedFlight_wrapper, { [css.priceWithNote]: showNote }) },
        React.createElement(CoreSelectedFlight, Object.assign({}, props)),
        showNote && (React.createElement("div", { className: css.currencyWarning_wrapper },
            "* ",
            React.createElement(CurrencyWarning, { total: props.order.priceToPay.total })))));
};
const mapStateToProps = (state) => ({
    order: getOrder(state)
});
export default connect(mapStateToProps)(SelectedFlight);
